<template>
  <collapsible-transition :show-transition-on-appear="showTransition">
    <card-panel-list-item
      :need-review="needReview"
      :clickable="clickable"
      @click="$emit('click')">
      <p slot="title" class="paragraph paragraph-bold">
        <span>{{ title }}</span>
      </p>
      <list-item-general-info
        slot="left-column"
        :description="description"
        :location="location"
        :clickable="clickable">
      </list-item-general-info>

      <div slot="right-column">
        <div>
          <span v-if="isStatusHired">{{ hurrayIcon }}</span>
          <referral-status-badge :status="status"></referral-status-badge>
        </div>
        <formatted-date :date="date"></formatted-date>
      </div>
    </card-panel-list-item>
  </collapsible-transition>
</template>

<script>

import CardPanelListItem from 'top20common/components/card-panel/CardPanelListItem';
import CollapsibleTransition from 'top20common/components/collapsible/CollapsibleTransition';

import ReferralStatusBadge from '@/common/badges/ReferralStatusBadge';
import {STATUS_HIRED} from '@/utils/constants/referrals';

import FormattedDate from '../common/FormattedDate';
import ListItemGeneralInfo from '../common/ListItemGeneralInfo';
import LocationWithIcon from '../common/LocationWithIcon';

export default {
  props: {
    title: String,
    needReview: Boolean,
    description: String,
    location: {type: String, default: ''},
    status: String,
    date: String,
    clickable: {type: Boolean, default: false}
  },
  mounted() {
    this.showTransition = true;
  },
  data() {
    return {
      hurrayIcon: '🎉',
      showTransition: false
    };
  },
  computed: {
    isStatusHired() {
      return this.status === STATUS_HIRED;
    }
  },
  components: {
    CardPanelListItem,
    ListItemGeneralInfo,
    FormattedDate,
    LocationWithIcon,
    ReferralStatusBadge,
    CollapsibleTransition
  }
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  .no-wrap {
    white-space: nowrap;
  }
}
/deep/ .fill {
  fill: var(--gray);
}

.collapsible-enter-active {
  transition: height 0.2s ease-in-out 0.6s, opacity 0.2s ease-in-out 0.8s;
  overflow: hidden;
}
</style>
